<template>
  <div class="table-view">
    <div aria-label="提供按服务对象筛选、服务部门、按事项关键词进行搜索" wzades="提供按服务对象筛选、服务部门、按事项关键词进行搜索">
      <ListSelect :selectData="serverType" tip="服务对象" :getItem="selectType" />
      <ListSelect :selectData="departmentList" tip="服务部门" keyName="unitName" id="unitSeq" :getItem="selectDepartment"/>
      <div class="input-wrap">
        <span class="input-wrap-text">您要办理什么事项？</span>
        <input class="search" type="text" placeholder="请输入事项名称" v-model="approveName" @keyup.enter="getNameCall" />
        <i class="icon el-icon-search" @click="getNameCall"></i>
      </div>
    </div>
    <div class="table-wrap" aria-label="提供各种事项服务" wzades="提供各种事项服务">
      <el-table :data="itemsList" style="width: 100%">
        <el-table-column label="事项名称">
          <template slot-scope="scope">
            <div class="name"><a href="javascript://" :class="['name-option', {'none-link': !scope.row.applyUrl}]" @click="linktoUrl(scope.row.applyUrl)">{{scope.row.approveName}}</a></div>
          </template>
        </el-table-column>
        <el-table-column  label="事项类型" width="200">
          <template slot-scope="scope">
            {{scope.row.programTypeDesc ? scope.row.programTypeDesc : '-'}}
          </template>
        </el-table-column>
        <el-table-column label="服务对象" width="150">
          <template slot-scope="scope">
            {{scope.row.serviceObjectDesc ? scope.row.serviceObjectDesc : '-'}}
          </template>
        </el-table-column>
        <el-table-column prop="unitName" label="服务部门" width="250">
        </el-table-column>
        <el-table-column label="操作" width="100" align="right">
          <template slot-scope="scope">
            <a href="javascript://" :class="['name-option', {'none-link': !scope.row.applyUrl}]" @click="linktoUrl(scope.row.applyUrl)">在线办理</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import ListSelect from './ListSelect.vue';
export default {
  components: { ListSelect },
  props: {
    keyword: {
      type: String,
      default: ""
    },
    itemsList: {
      type: Array
    },
    departmentList: {
      type: Array
    },
    'getListCall': {
      type: Function,
      required: true
    },
  },
  computed: {
    serverType() {
      return [{ id: '', name: '全部' }, { id: '1', name: '个人' }, { id: '2', name: '法人' }]
    },
  },
  data() {
    return {
      unitCode: '',
      serviceObject: '',
      approveName:''
    }
  },
  watch: {
    keyword(newVal) {
      this.approveName = newVal;
    }
  },
  methods: {
    selectDepartment(unitCode) {
      this.unitCode = unitCode;
      this.getListCall(this.approveName, this.serviceObject, this.unitCode);
    },
    selectType(serviceObject) {
      this.serviceObject = serviceObject;
      this.getListCall(this.approveName, this.serviceObject, this.unitCode);
    },
    getNameCall() {
      this.getListCall(this.approveName, this.serviceObject, this.unitCode);
    },
    linktoUrl(url){
      url && window.open(url);
    },
  },
  mounted() {
  }
}
</script>
<style lang="scss">
.table-view {
  padding-top: 16px;
  .table-wrap {
    overflow: hidden;
    padding-top: 30px;
    .el-table::before{
      background-color: transparent;
    }
    table {
      tr {
        .name {
          letter-spacing: 0;
          overflow: hidden;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          /*要显示的行数*/
          -webkit-box-orient: vertical;

          &:hover {
            cursor: pointer;

            a {
              color: #3E97DF;
              text-decoration: none;
            }
          }
        }

        th,
        td {
          font-size: 16px;
          color: #0D1C28;

          .name-option {
            color: #3E97DF;
            text-decoration: none;
            &.none-link{
              // opacity: 0.5;
              color: #333;
              cursor: no-drop;
            }
          }
        }
        th{
          color: #727475;
          font-weight: 400;
        }
      }
    }
  }

  .total-wrap {
    margin-top: 40px;
    margin-bottom: 24px;
    font-size: 16px;
    color: #727475;
  }

  .input-wrap {
    font-size: 16px;
    width: 540px;
    // border: 1px solid black;
    margin-top: 40px;

    .input-wrap-text {
      font-weight: 500;
      color: #0D1C28;
      margin-right: 10px;
    }

    input {
      width: 291px;
      height: 40px;
      background: #FFFFFF;
      border: 1px solid #D5D5D5;
      color: #666;
      padding-left: 15px;
      padding-right: 10px;
      display: inline-block;
      box-sizing: border-box;
      font-weight: 400;
      font-size: 14px;

      &:focus {
        border-color: #409EFF;
        outline: 0;
      }

      &::-webkit-input-placeholder {
        /* WebKit browsers */

        color: #B6BABE;
        font-size: 14px;
      }

      &::-moz-placeholder {
        /* Mozilla Firefox 19+ */

        color: #B6BABE;
        ;
        font-size: 14px;
      }

      &:-ms-input-placeholder {
        /* Internet Explorer 10+ */

        color: #B6BABE;
        font-size: 14px;
      }
    }

    .icon:before {
      left: -30px;
      top: -2px;
      position: relative;
      cursor: pointer;
      display: inline-block;
      text-align: center;
      font-size: 14px;
      line-height: 40px;
      vertical-align: middle;
    }
  }
  .page{
    button{
      border: 0px;
    }
  }
}
</style>